module.exports = __webpack_public_path__ + "static/media/13_tromp_a.76cf43dd.ogg";